import { useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CalendarCheck, Download, Loader2, Ticket } from "lucide-react";
import { toast } from "sonner";
import { MetricCard, SectionHeading } from "./ui";

export default function EventOverview({ data, cap }) {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const res = await api.get("/admin/event/registrations.csv", { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "cinevoya-event-attendees.csv";
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("Could not download attendee list");
    } finally {
      setBusy(false);
    }
  };
  return (
    <section data-testid="event-overview">
      <SectionHeading
        eyebrow="Launch event"
        title="Event registrations"
        description="RSVPs for the Cinevoya launch event. Download the full attendee list as CSV (opens in Excel or Google Sheets)."
        action={
          <Button onClick={download} disabled={busy} className="bg-terracotta hover:bg-ember text-white h-10 rounded-full px-5" data-testid="event-download-csv-btn">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />} Download attendee list
          </Button>
        }
      />
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        <MetricCard accent label="Registrations" value={(data?.registrations || 0).toLocaleString()} icon={CalendarCheck} tone="text-gold" testId="event-registrations-total" />
        <MetricCard label="Seats taken (incl. guests)" value={(data?.seats_taken || 0).toLocaleString()} hint={cap ? `of ${cap} capacity` : undefined} icon={Ticket} testId="event-seats-taken" />
      </div>
    </section>
  );
}
